<template>
  <div class="content-body">
    <div class="top">推广链接</div>
    <div class="body">
      <el-button type="primary" icon="el-icon-plus" size="small" @click="addPlan">新建推广链接</el-button>
      <div class="condition">
        <div class="form">
          <div class="demo-input-suffix">
            广告主:
            <el-select v-model="form.type" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option :label="company_name" value="1"></el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            链接名称:
            <el-input v-model="form.keyword" placeholder="" style="width: 160px; margin-left: 10px;" size="small"></el-input>
          </div>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" border style="width: 1371px" size="small" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
          <el-table-column label="链接名称" prop="link_name" align="center" />
          <el-table-column label="点击目标链接" prop="click_target_link" align="center">
            <template slot-scope="scope">
              <a :href="scope.row.click_target_link" target="_blank">{{ scope.row.click_target_link }}</a>
            </template>
          </el-table-column>
          <el-table-column label="最终登录页链接" prop="login_link" align="center">
            <template slot-scope="scope">
              <a :href="scope.row.login_link" target="_blank">{{ scope.row.login_link }}</a>
            </template>
          </el-table-column>
          <el-table-column label="第三方曝光检测" prop="show_link" align="center">
            <template slot-scope="scope">
              <a :href="scope.row.show_link" target="_blank">{{ scope.row.show_link }}</a>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="editOne(scope.$index)">编辑</el-button>
              <el-button type="text" style="color: red;" size="mini" @click="delOne(scope.row.link_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-c">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title="新建推广链接"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%">
      <el-form ref="form" label-width="120px" label-position="left">
        <el-form-item label="账户资质">
          <el-input v-model="company_name" placeholder="" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="推广链接名称" class="is-required">
          <el-input v-model="saveData.link_name" placeholder="推广链接名称"></el-input>
        </el-form-item>
        <el-form-item label="点击目标链接" class="is-required">
          <el-input v-model="saveData.click_target_link" placeholder="例：https://123456.com"></el-input>
        </el-form-item>
        <el-form-item label="最终登录页链接" class="is-required">
          <el-input v-model="saveData.login_link" placeholder="例：https://123456.com"></el-input>
        </el-form-item>
        <el-form-item label="第三方曝光检测" class="is-required">
          <el-input v-model="saveData.show_link" placeholder="例：https://123456.com"></el-input>
        </el-form-item>
        <el-form-item label="" class="is-required">
          应官方媒体要求，所有投放链接都应为https，http链接不确定是否可用
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveLink">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑推广链接"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
      width="40%">
      <el-form ref="form" label-width="120px" label-position="left">
        <el-form-item label="账户资质">
          <el-input v-model="company_name" placeholder="" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="推广链接名称" class="is-required">
          <el-input v-model="editData.link_name" placeholder="推广链接名称"></el-input>
        </el-form-item>
        <el-form-item label="点击目标链接" class="is-required">
          <el-input v-model="editData.click_target_link" placeholder="例：https://123456.com"></el-input>
        </el-form-item>
        <el-form-item label="最终登录页链接" class="is-required">
          <el-input v-model="editData.login_link" placeholder="例：https://123456.com"></el-input>
        </el-form-item>
        <el-form-item label="第三方曝光检测" class="is-required">
          <el-input v-model="editData.show_link" placeholder="例：https://123456.com"></el-input>
        </el-form-item>
        <el-form-item label="" class="is-required">
          应官方媒体要求，所有投放链接都应为https，http链接不确定是否可用
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="editLink">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      form: {
        status: '',
        type: '',
        keyword: '',
        isData: false,
        time: ''
      },
      saveData: {
        link_name: "",
        click_target_link: "",
        login_link: "",
        show_link: "",
      },
      editData: {
        link_id: 0,
        link_name: "",
        click_target_link: "",
        login_link: "",
        show_link: "",
      },
      dialogVisible: false,
      dialogVisible2: false,
      page: 1,
      checked: 1,
      old_input: '',
      old_title: '',
      input: '',
      title: '',
      plan_id: 0,
      pageSize: 10,
      pageTotal: 1,
      tableData: [],
      company_name: ''
    };
  },
  mounted() {
    this.company_name = JSON.parse(sessionStorage.getItem('user_info'))['company_name'];
    const day2 = new Date();
    day2.setTime(day2.getTime());
    this.form.time = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate();
    this.getData();
  },
  methods: {
    saveLink() {
      this.$http.post('/trader/link/createLink', this.saveData).then(res => {
        if (res.code === 200) {
          this.getData();
          this.dialogVisible = false;
          this.$function.hiddenLoading();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    editLink() {
      this.$http.post('/trader/link/saveLink', this.editData).then(res => {
        if (res.code === 200) {
          this.getData();
          this.dialogVisible2 = false;
          this.$function.hiddenLoading();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getData() {
      this.$http.post('/trader/link/getLinkLists', {
        keyword: this.form.keyword,
        page: this.page,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    search() {
      this.tableData = [];
      this.page = 1;
      this.getData();
    },
    addPlan() {
      this.dialogVisible = true;
    },
    editOne(index) {
      const item = this.tableData[index];
      this.editData = {
        link_id: item.link_id,
        link_name: item.link_name,
        click_target_link: item.click_target_link,
        login_link: item.login_link,
        show_link: item.show_link,
      },
      this.dialogVisible2 = true;
    },
    delOne(link_id) {
      if (link_id > 0) {
        this.$http.post('/trader/link/del', {
          link_id
        }).then(res => {
          if (res.code === 200) {
            this.getData();
          }
        });
      }
    },
  },
  watch: {

  }
};
</script>

<style lang="less" scoped>
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    line-height: 54px;
    color: #333;
    padding-left: 22px;
  }
  .body {
    width: calc(100% - 69px);
    margin-left: 23px;
    width: 1400px;
    .condition {
      margin-top: 20px;
      width: 1400px;
      height: 55px;
      .form {
        float: left;
        width: 950px;
      }
      .other {
        float: right;
        width: 440px;
      }
      .demo-input-suffix {
        display: inline-block;
        font-size: 14px;
        color: #999;
        margin-right: 31px;
      }
    }
    .page-c {
      margin-top: 20px;
      text-align: right;
      margin-right: 30px;
    }
  }

</style>
